module.exports = __webpack_public_path__ + "img/message-icon.94ffd970.svg";